<template>

    <form-with-loader :form="form" @success="refresh" @error="setServerError" class="login-form">
        <h3>Let's get this party started!</h3>
        <p v-if="serverError" class="login-error">
            This account exists already!
        </p>
        <label>
            <div class="label-text email-label">Email</div>
            <error :error="form.validator.getError('email')"></error>
            <input
                    v-model="form.email"
                    type="email"
                    @change="form.validateField('email')"
                    @focus="shrinkLabel('email-label', $event)"
                    @blur="growLabel('email-label', $event)">
        </label>
        <label>
            <div class="label-text name-label">Name</div>
            <error :error="form.validator.getError('name')"></error>
            <input
                    type="text"
                    v-model="form.name"
                    @change="form.validateField('name')"
                    @focus="shrinkLabel('name-label', $event)"
                    @blur="growLabel('name-label', $event)">
        </label>
        <label>
            <div class="label-text password-label">Password</div>
            <error :error="form.validator.getError('password')"></error>
            <input
                    v-model="form.password"
                    type="password"
                    @change="form.validateField('email')"
                    @focus="shrinkLabel('password-label', $event)"
                    @blur="growLabel('password-label', $event)">
        </label>
    </form-with-loader>
</template>

<script>
    import VuetifulForm   from "vuetiful-forms/src/components/VuetifulForm";
    import RegisterForm   from "../../Forms/RegisterForm";
    import Error          from "vuetiful-forms/src/components/Error";
    import labelAnimation from "../../../../Lib/Mixins/labelAnimation";
    import FormWithLoader from "../../../../App/Views/Components/FormWithLoader";
    import refresh        from "../../../../Lib/Mixins/refresh";
    import serverError    from "../../../../Lib/Mixins/serverError";

    export default {
        name      : "Register",
        mixins    : [labelAnimation, refresh, serverError],
        components: { FormWithLoader, Error, VuetifulForm },

        data() {
            return {
                form    : new RegisterForm(),
                hasError: false,
            }
        },

        mounted() {
            this.form.email = this.$store.state.signUpEmail;
        }
    }
</script>

<style scoped>

</style>
